<section *ngIf="loading">
  <div class="row p-2">
    <div class="col-md-12 card card-body">
      <h4 class="h4-responsive text-center">Loading...</h4>
    </div>
  </div>
  <div class="row p-2 text-center">
    <app-spin-icon class="ml-auto mr-auto" [spinnerType]="big"></app-spin-icon>
  </div>
</section>
<section *ngIf="!loading">
  <div class="row">
    <dac-exercise *ngIf="shouldDisplayExercise()" class="col" [exercise]="asset" (onSubmit)="submitAsset($event)"
      [disabled]="saving"></dac-exercise>
    <dac-article *ngIf="shouldDisplayArticle()" class="col" [article]="asset" (onSubmit)="submitAsset($event)"
      [disabled]="saving"></dac-article>
  </div>
</section>


// WEBPACK FOOTER //
// ./src/app/assessments/take-asset-external/take-asset-external.component.html